var m = Uint8Array, C = Uint16Array, or = Int32Array, lr = new m([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  0,
  0,
  0
]), ur = new m([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  0,
  0
]), Mr = new m([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), Zr = function(a, r) {
  for (var t = new C(31), n = 0; n < 31; ++n) t[n] = r += 1 << a[n - 1];
  for (var i = new or(t[30]), n = 1; n < 30; ++n) for (var e = t[n]; e < t[n + 1]; ++e) i[e] = e - t[n] << 5 | n;
  return {
    b: t,
    r: i
  };
}, Sr = Zr(lr, 2), Ir = Sr.b, vr = Sr.r;
Ir[28] = 258, vr[258] = 28;
var Ur = Zr(ur, 0), Xr = Ur.b, pr = Ur.r, fr = new C(32768);
for (var g = 0; g < 32768; ++g) {
  var R = (g & 43690) >> 1 | (g & 21845) << 1;
  R = (R & 52428) >> 2 | (R & 13107) << 2, R = (R & 61680) >> 4 | (R & 3855) << 4, fr[g] = ((R & 65280) >> 8 | (R & 255) << 8) >> 1;
}
var d = (function(a, r, t) {
  for (var n = a.length, i = 0, e = new C(r); i < n; ++i) a[i] && ++e[a[i] - 1];
  var s = new C(r);
  for (i = 1; i < r; ++i) s[i] = s[i - 1] + e[i - 1] << 1;
  var f;
  if (t) {
    f = new C(1 << r);
    var l = 15 - r;
    for (i = 0; i < n; ++i) if (a[i])
      for (var h = i << 4 | a[i], v = r - a[i], y = s[a[i] - 1]++ << v, c = y | (1 << v) - 1; y <= c; ++y) f[fr[y] >> l] = h;
  } else
    for (f = new C(n), i = 0; i < n; ++i) a[i] && (f[i] = fr[s[a[i] - 1]++] >> 15 - a[i]);
  return f;
}), V = new m(288);
for (var g = 0; g < 144; ++g) V[g] = 8;
for (var g = 144; g < 256; ++g) V[g] = 9;
for (var g = 256; g < 280; ++g) V[g] = 7;
for (var g = 280; g < 288; ++g) V[g] = 8;
var rr = new m(32);
for (var g = 0; g < 32; ++g) rr[g] = 5;
var Pr = /* @__PURE__ */ d(V, 9, 0);
var qr = /* @__PURE__ */ d(rr, 5, 0);
var Cr = function(a) {
  return (a + 7) / 8 | 0;
}, Fr = function(a, r, t) {
  return (r == null || r < 0) && (r = 0), (t == null || t > a.length) && (t = a.length), new m(a.subarray(r, t));
}, Hr = [
  "unexpected EOF",
  "invalid block type",
  "invalid length/literal",
  "invalid distance",
  "stream finished",
  "no stream handler",
  ,
  "no callback",
  "invalid UTF-8 data",
  "extra field too long",
  "date not in range 1980-2099",
  "filename too long",
  "stream finishing",
  "invalid zip data"
], P = function(a, r, t) {
  var n = new Error(r || Hr[a]);
  if (n.code = a, Error.captureStackTrace && Error.captureStackTrace(n, P), !t) throw n;
  return n;
}, N = function(a, r, t) {
  t <<= r & 7;
  var n = r / 8 | 0;
  a[n] |= t, a[n + 1] |= t >> 8;
}, k = function(a, r, t) {
  t <<= r & 7;
  var n = r / 8 | 0;
  a[n] |= t, a[n + 1] |= t >> 8, a[n + 2] |= t >> 16;
}, sr = function(a, r) {
  for (var t = [], n = 0; n < a.length; ++n) a[n] && t.push({
    s: n,
    f: a[n]
  });
  var i = t.length, e = t.slice();
  if (!i) return {
    t: ar,
    l: 0
  };
  if (i == 1) {
    var s = new m(t[0].s + 1);
    return s[t[0].s] = 1, {
      t: s,
      l: 1
    };
  }
  t.sort(function(I, H) {
    return I.f - H.f;
  }), t.push({
    s: -1,
    f: 25001
  });
  var f = t[0], l = t[1], h = 0, v = 1, y = 2;
  for (t[0] = {
    s: -1,
    f: f.f + l.f,
    l: f,
    r: l
  }; v != i - 1; )
    f = t[t[h].f < t[y].f ? h++ : y++], l = t[h != v && t[h].f < t[y].f ? h++ : y++], t[v++] = {
      s: -1,
      f: f.f + l.f,
      l: f,
      r: l
    };
  for (var c = e[0].s, n = 1; n < i; ++n) e[n].s > c && (c = e[n].s);
  var z = new C(c + 1), M = hr(t[v - 1], z, 0);
  if (M > r) {
    var n = 0, w = 0, p = M - r, A = 1 << p;
    for (e.sort(function(H, E) {
      return z[E.s] - z[H.s] || H.f - E.f;
    }); n < i; ++n) {
      var F = e[n].s;
      if (z[F] > r)
        w += A - (1 << M - z[F]), z[F] = r;
      else break;
    }
    for (w >>= p; w > 0; ) {
      var Z = e[n].s;
      z[Z] < r ? w -= 1 << r - z[Z]++ - 1 : ++n;
    }
    for (; n >= 0 && w; --n) {
      var q = e[n].s;
      z[q] == r && (--z[q], ++w);
    }
    M = r;
  }
  return {
    t: new m(z),
    l: M
  };
}, hr = function(a, r, t) {
  return a.s == -1 ? Math.max(hr(a.l, r, t + 1), hr(a.r, r, t + 1)) : r[a.s] = t;
}, Tr = function(a) {
  for (var r = a.length; r && !a[--r]; ) ;
  for (var t = new C(++r), n = 0, i = a[0], e = 1, s = function(l) {
    t[n++] = l;
  }, f = 1; f <= r; ++f) if (a[f] == i && f != r) ++e;
  else {
    if (!i && e > 2) {
      for (; e > 138; e -= 138) s(32754);
      e > 2 && (s(e > 10 ? e - 11 << 5 | 28690 : e - 3 << 5 | 12305), e = 0);
    } else if (e > 3) {
      for (s(i), --e; e > 6; e -= 6) s(8304);
      e > 2 && (s(e - 3 << 5 | 8208), e = 0);
    }
    for (; e--; ) s(i);
    e = 1, i = a[f];
  }
  return {
    c: t.subarray(0, n),
    n: r
  };
}, b = function(a, r) {
  for (var t = 0, n = 0; n < r.length; ++n) t += a[n] * r[n];
  return t;
}, cr = function(a, r, t) {
  var n = t.length, i = Cr(r + 2);
  a[i] = n & 255, a[i + 1] = n >> 8, a[i + 2] = a[i] ^ 255, a[i + 3] = a[i + 1] ^ 255;
  for (var e = 0; e < n; ++e) a[i + e + 4] = t[e];
  return (i + 4 + n) * 8;
}, mr = function(a, r, t, n, i, e, s, f, l, h, v) {
  N(r, v++, t), ++i[256];
  for (var y = sr(i, 15), c = y.t, z = y.l, M = sr(e, 15), w = M.t, p = M.l, A = Tr(c), F = A.c, Z = A.n, q = Tr(w), I = q.c, H = q.n, E = new C(19), u = 0; u < F.length; ++u) ++E[F[u] & 31];
  for (var u = 0; u < I.length; ++u) ++E[I[u] & 31];
  for (var o = sr(E, 7), S = o.t, W = o.l, U = 19; U > 4 && !S[Mr[U - 1]]; --U) ;
  var X = h + 5 << 3, L = b(i, V) + b(e, rr) + s, O = b(i, c) + b(e, w) + s + 14 + 3 * U + b(E, S) + 2 * E[16] + 3 * E[17] + 7 * E[18];
  if (l >= 0 && X <= L && X <= O) return cr(r, v, a.subarray(l, l + h));
  var G, x, Y, Q;
  if (N(r, v, 1 + (O < L)), v += 2, O < L) {
    G = d(c, z, 0), x = c, Y = d(w, p, 0), Q = w;
    var tr = d(S, W, 0);
    N(r, v, Z - 257), N(r, v + 5, H - 1), N(r, v + 10, U - 4), v += 14;
    for (var u = 0; u < U; ++u) N(r, v + 3 * u, S[Mr[u]]);
    v += 3 * U;
    for (var J = [F, I], j = 0; j < 2; ++j)
      for (var $ = J[j], u = 0; u < $.length; ++u) {
        var K = $[u] & 31;
        N(r, v, tr[K]), v += S[K], K > 15 && (N(r, v, $[u] >> 5 & 127), v += $[u] >> 12);
      }
  } else G = Pr, x = V, Y = qr, Q = rr;
  for (var u = 0; u < f; ++u) {
    var D = n[u];
    if (D > 255) {
      var K = D >> 18 & 31;
      k(r, v, G[K + 257]), v += x[K + 257], K > 7 && (N(r, v, D >> 23 & 31), v += lr[K]);
      var B = D & 31;
      k(r, v, Y[B]), v += Q[B], B > 3 && (k(r, v, D >> 5 & 8191), v += ur[B]);
    } else k(r, v, G[D]), v += x[D];
  }
  return k(r, v, G[256]), v + x[256];
}, Lr = /* @__PURE__ */ new or([
  65540,
  131080,
  131088,
  131104,
  262176,
  1048704,
  1048832,
  2114560,
  2117632
]), ar = /* @__PURE__ */ new m(0), Or = function(a, r, t, n, i, e) {
  var s = e.z || a.length, f = new m(n + s + 5 * (1 + Math.ceil(s / 7e3)) + i), l = f.subarray(n, f.length - i), h = e.l, v = (e.r || 0) & 7;
  if (r) {
    v && (l[0] = e.r >> 3);
    for (var y = Lr[r - 1], c = y >> 13, z = y & 8191, M = (1 << t) - 1, w = e.p || new C(32768), p = e.h || new C(M + 1), A = Math.ceil(t / 3), F = 2 * A, Z = function(ir) {
      return (a[ir] ^ a[ir + 1] << A ^ a[ir + 2] << F) & M;
    }, q = new or(25e3), I = new C(288), H = new C(32), E = 0, u = 0, o = e.i || 0, S = 0, W = e.w || 0, U = 0; o + 2 < s; ++o) {
      var X = Z(o), L = o & 32767, O = p[X];
      if (w[L] = O, p[X] = L, W <= o) {
        var G = s - o;
        if ((E > 7e3 || S > 24576) && (G > 423 || !h)) {
          v = mr(a, l, 0, q, I, H, u, S, U, o - U, v), S = E = u = 0, U = o;
          for (var x = 0; x < 286; ++x) I[x] = 0;
          for (var x = 0; x < 30; ++x) H[x] = 0;
        }
        var Y = 2, Q = 0, tr = z, J = L - O & 32767;
        if (G > 2 && X == Z(o - J))
          for (var j = Math.min(c, G) - 1, $ = Math.min(32767, o), K = Math.min(258, G); J <= $ && --tr && L != O; ) {
            if (a[o + Y] == a[o + Y - J]) {
              for (var D = 0; D < K && a[o + D] == a[o + D - J]; ++D) ;
              if (D > Y) {
                if (Y = D, Q = J, D > j) break;
                for (var B = Math.min(J, D - 2), gr = 0, x = 0; x < B; ++x) {
                  var nr = o - J + x & 32767, wr = nr - w[nr] & 32767;
                  wr > gr && (gr = wr, O = nr);
                }
              }
            }
            L = O, O = w[L], J += L - O & 32767;
          }
        if (Q) {
          q[S++] = 268435456 | vr[Y] << 18 | pr[Q];
          var yr = vr[Y] & 31, zr = pr[Q] & 31;
          u += lr[yr] + ur[zr], ++I[257 + yr], ++H[zr], W = o + Y, ++E;
        } else
          q[S++] = a[o], ++I[a[o]];
      }
    }
    for (o = Math.max(o, W); o < s; ++o)
      q[S++] = a[o], ++I[a[o]];
    v = mr(a, l, h, q, I, H, u, S, U, o - U, v), h || (e.r = v & 7 | l[v / 8 | 0] << 3, v -= 7, e.h = p, e.p = w, e.i = o, e.w = W);
  } else {
    for (var o = e.w || 0; o < s + h; o += 65535) {
      var er = o + 65535;
      er >= s && (l[v / 8 | 0] = h, er = s), v = cr(l, v + 1, a.subarray(o, er));
    }
    e.i = s;
  }
  return Fr(f, 0, n + Cr(v) + i);
}, Yr = /* @__PURE__ */ (function() {
  for (var a = new Int32Array(256), r = 0; r < 256; ++r) {
    for (var t = r, n = 9; --n; ) t = (t & 1 && -306674912) ^ t >>> 1;
    a[r] = t;
  }
  return a;
})(), Gr = function() {
  var a = -1;
  return {
    p: function(r) {
      for (var t = a, n = 0; n < r.length; ++n) t = Yr[t & 255 ^ r[n]] ^ t >>> 8;
      a = t;
    },
    d: function() {
      return ~a;
    }
  };
}, Jr = function(a, r, t, n, i) {
  if (!i && (i = { l: 1 }, r.dictionary)) {
    var e = r.dictionary.subarray(-32768), s = new m(e.length + a.length);
    s.set(e), s.set(a, e.length), a = s, i.w = e.length;
  }
  return Or(a, r.level == null ? 6 : r.level, r.mem == null ? i.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(a.length))) * 1.5) : 20 : 12 + r.mem, t, n, i);
}, Kr = function(a, r) {
  var t = {};
  for (var n in a) t[n] = a[n];
  for (var n in r) t[n] = r[n];
  return t;
}, T = function(a, r, t) {
  for (; t; ++r) a[r] = t, t >>>= 8;
}, Nr = /* @__PURE__ */ (function() {
  function a(r, t) {
    if (typeof r == "function" && (t = r, r = {}), this.ondata = t, this.o = r || {}, this.s = {
      l: 0,
      i: 32768,
      w: 32768,
      z: 32768
    }, this.b = new m(98304), this.o.dictionary) {
      var n = this.o.dictionary.subarray(-32768);
      this.b.set(n, 32768 - n.length), this.s.i = 32768 - n.length;
    }
  }
  return a.prototype.p = function(r, t) {
    this.ondata(Jr(r, this.o, 0, 0, this.s), t);
  }, a.prototype.push = function(r, t) {
    this.ondata || P(5), this.s.l && P(4);
    var n = r.length + this.s.z;
    if (n > this.b.length) {
      if (n > 2 * this.b.length - 32768) {
        var i = new m(n & -32768);
        i.set(this.b.subarray(0, this.s.z)), this.b = i;
      }
      var e = this.b.length - this.s.z;
      this.b.set(r.subarray(0, e), this.s.z), this.s.z = this.b.length, this.p(this.b, !1), this.b.set(this.b.subarray(-32768)), this.b.set(r.subarray(e), 32768), this.s.z = r.length - e + 32768, this.s.i = 32766, this.s.w = 32768;
    } else
      this.b.set(r, this.s.z), this.s.z += r.length;
    this.s.l = t & 1, (this.s.z > this.s.w + 8191 || t) && (this.p(this.b, t || !1), this.s.w = this.s.i, this.s.i -= 2), t && (this.s = this.o = {}, this.b = ar);
  }, a.prototype.flush = function(r) {
    if (this.ondata || P(5), this.s.l && P(4), this.p(this.b, !1), this.s.w = this.s.i, this.s.i -= 2, r) {
      var t = new m(6);
      t[0] = this.s.r >> 3;
      var n = cr(t, this.s.r, ar);
      this.s.r = 0, this.ondata(t.subarray(0, n >> 3), !1);
    }
  }, a;
})(), xr = typeof TextEncoder < "u" && /* @__PURE__ */ new TextEncoder(), Qr = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), Rr = 0;
try {
  Qr.decode(ar, { stream: !0 }), Rr = 1;
} catch {
}
function Dr(a, r) {
  if (r) {
    for (var t = new m(a.length), n = 0; n < a.length; ++n) t[n] = a.charCodeAt(n);
    return t;
  }
  if (xr) return xr.encode(a);
  for (var i = a.length, e = new m(a.length + (a.length >> 1)), s = 0, f = function(v) {
    e[s++] = v;
  }, n = 0; n < i; ++n) {
    if (s + 5 > e.length) {
      var l = new m(s + 8 + (i - n << 1));
      l.set(e), e = l;
    }
    var h = a.charCodeAt(n);
    h < 128 || r ? f(h) : h < 2048 ? (f(192 | h >> 6), f(128 | h & 63)) : h > 55295 && h < 57344 ? (h = 65536 + (h & 1047552) | a.charCodeAt(++n) & 1023, f(240 | h >> 18), f(128 | h >> 12 & 63), f(128 | h >> 6 & 63), f(128 | h & 63)) : (f(224 | h >> 12), f(128 | h >> 6 & 63), f(128 | h & 63));
  }
  return Fr(e, 0, s);
}
var Vr = function(a) {
  return a == 1 ? 3 : a < 6 ? 2 : a == 9 ? 1 : 0;
}, _ = function(a) {
  var r = 0;
  if (a) for (var t in a) {
    var n = a[t].length;
    n > 65535 && P(9), r += n + 4;
  }
  return r;
}, Ar = function(a, r, t, n, i, e, s, f) {
  var l = n.length, h = t.extra, v = f && f.length, y = _(h);
  T(a, r, s != null ? 33639248 : 67324752), r += 4, s != null && (a[r++] = 20, a[r++] = t.os), a[r] = 20, r += 2, a[r++] = t.flag << 1 | (e < 0 && 8), a[r++] = i && 8, a[r++] = t.compression & 255, a[r++] = t.compression >> 8;
  var c = new Date(t.mtime == null ? Date.now() : t.mtime), z = c.getFullYear() - 1980;
  if ((z < 0 || z > 119) && P(10), T(a, r, z << 25 | c.getMonth() + 1 << 21 | c.getDate() << 16 | c.getHours() << 11 | c.getMinutes() << 5 | c.getSeconds() >> 1), r += 4, e != -1 && (T(a, r, t.crc), T(a, r + 4, e < 0 ? -e - 2 : e), T(a, r + 8, t.size)), T(a, r + 12, l), T(a, r + 14, y), r += 16, s != null && (T(a, r, v), T(a, r + 6, t.attrs), T(a, r + 10, s), r += 14), a.set(n, r), r += l, y) for (var M in h) {
    var w = h[M], p = w.length;
    T(a, r, +M), T(a, r + 2, p), a.set(w, r + 4), r += 4 + p;
  }
  return v && (a.set(f, r), r += v), r;
}, Wr = function(a, r, t, n, i) {
  T(a, r, 101010256), T(a, r + 8, t), T(a, r + 10, t), T(a, r + 12, n), T(a, r + 16, i);
}, Er = /* @__PURE__ */ (function() {
  function a(r) {
    this.filename = r, this.c = Gr(), this.size = 0, this.compression = 0;
  }
  return a.prototype.process = function(r, t) {
    this.ondata(null, r, t);
  }, a.prototype.push = function(r, t) {
    this.ondata || P(5), this.c.p(r), this.size += r.length, t && (this.crc = this.c.d()), this.process(r, t || !1);
  }, a;
})(), $r = /* @__PURE__ */ (function() {
  function a(r, t) {
    var n = this;
    t || (t = {}), Er.call(this, r), this.d = new Nr(t, function(i, e) {
      n.ondata(null, i, e);
    }), this.compression = 8, this.flag = Vr(t.level);
  }
  return a.prototype.process = function(r, t) {
    try {
      this.d.push(r, t);
    } catch (n) {
      this.ondata(n, null, t);
    }
  }, a.prototype.push = function(r, t) {
    Er.prototype.push.call(this, r, t);
  }, a;
})(), Br = /* @__PURE__ */ (function() {
  function a(r) {
    this.ondata = r, this.u = [], this.d = 1;
  }
  return a.prototype.add = function(r) {
    var t = this;
    if (this.ondata || P(5), this.d & 2) this.ondata(P(4 + (this.d & 1) * 8, 0, 1), null, !1);
    else {
      var n = Dr(r.filename), i = n.length, e = r.comment, s = e && Dr(e), f = i != r.filename.length || s && e.length != s.length, l = i + _(r.extra) + 30;
      i > 65535 && this.ondata(P(11, 0, 1), null, !1);
      var h = new m(l);
      Ar(h, 0, r, n, f, -1);
      var v = [h], y = function() {
        for (var p = 0, A = v; p < A.length; p++) t.ondata(null, A[p], !1);
        v = [];
      }, c = this.d;
      this.d = 0;
      var z = this.u.length, M = Kr(r, {
        f: n,
        u: f,
        o: s,
        t: function() {
          r.terminate && r.terminate();
        },
        r: function() {
          if (y(), c) {
            var p = t.u[z + 1];
            p ? p.r() : t.d = 1;
          }
          c = 1;
        }
      }), w = 0;
      r.ondata = function(p, A, F) {
        if (p)
          t.ondata(p, A, F), t.terminate();
        else if (w += A.length, v.push(A), F) {
          var Z = new m(16);
          T(Z, 0, 134695760), T(Z, 4, r.crc), T(Z, 8, w), T(Z, 12, r.size), v.push(Z), M.c = w, M.b = l + w + 16, M.crc = r.crc, M.size = r.size, c && M.r(), c = 1;
        } else c && y();
      }, this.u.push(M);
    }
  }, a.prototype.end = function() {
    var r = this;
    if (this.d & 2) {
      this.ondata(P(4 + (this.d & 1) * 8, 0, 1), null, !0);
      return;
    }
    this.d ? this.e() : this.u.push({
      r: function() {
        r.d & 1 && (r.u.splice(-1, 1), r.e());
      },
      t: function() {
      }
    }), this.d = 3;
  }, a.prototype.e = function() {
    for (var r = 0, t = 0, n = 0, i = 0, e = this.u; i < e.length; i++) {
      var s = e[i];
      n += 46 + s.f.length + _(s.extra) + (s.o ? s.o.length : 0);
    }
    for (var f = new m(n + 22), l = 0, h = this.u; l < h.length; l++) {
      var s = h[l];
      Ar(f, r, s, s.f, s.u, -s.c - 2, t, s.o), r += 46 + s.f.length + _(s.extra) + (s.o ? s.o.length : 0), t += s.b;
    }
    Wr(f, r, this.u.length, n, t), this.ondata(null, f, !0), this.d = 2;
  }, a.prototype.terminate = function() {
    for (var r = 0, t = this.u; r < t.length; r++) t[r].t();
    this.d = 2;
  }, a;
})();
export {
  Dr as i,
  $r as n,
  Er as r,
  Br as t
};

//# sourceMappingURL=browser-w1WAp8je.js.map